import AppBar from '@mui/material/AppBar'
import Stack from '@mui/material/Stack'
import Toolbar from '@mui/material/Toolbar'
import Typography from '@mui/material/Typography'
import Logo from '../../../assets/icons/svg/Logo.svg'
import CountrySelection from '../../countrySelection/CountrySelection'
import { lowerCase } from 'lodash'
import { useAtomValue } from 'jotai'
import { countryState, languageState } from '@repo/unicity'
import MenuIcon from '../../../assets/icons/svg/MenuIcon.svg'

export function Header() {
    const country = useAtomValue(countryState)
    const language = useAtomValue(languageState)

    return (
        <AppBar position="static" sx={{ backgroundColor: 'background.paper' }} elevation={0}>
            <Toolbar sx={{ padding: '0px !important' }}>
                <Stack direction={'row'} alignItems={'center'} justifyContent={'space-between'} height={'64px'} width={'100%'}>
                    <Stack direction={'row'} alignItems={'center'} height={'100%'} width={'100%'}>
                        <Stack
                            direction={'row'}
                            alignItems={'center'}
                            gap={1}
                            width={'74px'}
                            sx={{ cursor: 'pointer' }}
                            borderRight={'1px solid #E0E0E0'}
                            justifyContent={'center'}
                            height={'100%'}
                            onClick={() => (window.location.href = `https://ushop.unicity.com/${lowerCase(country.roman_name)}/menu?lang=${language}`)}>
                            <img src={MenuIcon} alt="Menu Icon" />
                        </Stack>
                        <Stack direction={'row'} alignItems={'center'} gap={1} padding={'0px 20px'}>
                            <img src={Logo} alt="Unicity Logo" style={{ height: '15px' }} />
                            <Typography variant="h6">Unicity</Typography>
                        </Stack>
                    </Stack>
                    <CountrySelection />
                </Stack>
            </Toolbar>
        </AppBar>
    )
}
